import i18next from 'i18next';
import { toast } from 'react-toastify';

const sessionIdleWarningId = 'dec-admin-session-idle-warning';

export const showSessionIdleWarning = () => {
  toast.warn(i18next.t('common.messages.warningInactiveSession'), {
    autoClose: false,
    toastId: sessionIdleWarningId
  });
  return sessionIdleWarningId;
};

export const dismissSessionIdleWarning = (id = sessionIdleWarningId) => toast.dismiss(id);

export const notificationSuccess = (message: string) =>
  toast.success(message, {
    toastId: message,
    autoClose: 5000,
    hideProgressBar: true
  });
export const notificationError = (message: string) =>
  toast.error(message, {
    toastId: message,
    autoClose: 5000,
    hideProgressBar: true
  });
export const notificationWarning = (message: string) =>
  toast.warn(message, {
    toastId: message,
    autoClose: 5000,
    hideProgressBar: true
  });
export const notificationInfo = (message: string) =>
  toast.info(message, {
    toastId: message,
    autoClose: 5000,
    hideProgressBar: true
  });
